import api from "../../client";

export const deleteCampusActivityRequest = async (
  id: string | undefined,
): Promise<{}> => {
  const { data } = await api.delete(`/campus-activity/${id}`);

  return data;
};
